import * as z from "zod/v4";

export const batchUpdateRuleOrder = {
  name: "batchUpdateRuleOrder" as const,
  input: z.object({
    ruleOrders: z.array(z.object({ flowId: z.string(), index: z.number() })),
  }),
  output: z.object({ success: z.boolean() }),
};
